export enum Panel {
  MEMBERS = 'members',
  PUBLIC_FEED = 'public-feed',
}
